import { render, staticRenderFns } from "./UEditor.vue?vue&type=template&id=081b4654&scoped=true&"
import script from "./UEditor.vue?vue&type=script&lang=js&"
export * from "./UEditor.vue?vue&type=script&lang=js&"
import style0 from "./UEditor.vue?vue&type=style&index=0&id=081b4654&lang=scss&scoped=true&"
import style1 from "./UEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b4654",
  null
  
)

export default component.exports